export default __webpack_public_path__ + "static/media/Bandit's Armbands of the Howling Wind.541e40c9.jpg";